"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouritedOn = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FavouritedOn = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "favourited-on", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "favourited-on", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9.652 27.881 16 24.387l6.348 3.494a.947.947 0 0 0 .625.104c.537-.096.898-.63.806-1.192l-1.212-7.401 5.135-5.241c.155-.159.256-.367.288-.591.078-.565-.296-1.089-.835-1.171l-7.097-1.08-3.174-6.733a1.01 1.01 0 0 0-.448-.47c-.488-.252-1.08-.042-1.32.47l-3.175 6.733-7.096 1.08a.972.972 0 0 0-.565.301 1.067 1.067 0 0 0 .018 1.46l5.135 5.242-1.212 7.4c-.037.224-.002.455.1.656.253.505.849.699 1.331.433Z", fill: "#F5B52C", fillRule: "evenodd" }) })) })));
};
exports.FavouritedOn = FavouritedOn;
